import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
// import { Manager, Target, Popper } from "react-popper";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Paper from "@material-ui/core/Paper";
import Grow from "@material-ui/core/Grow";
import Hidden from "@material-ui/core/Hidden";
import Popper from "@material-ui/core/Popper";

// @material-ui/icons
import Person from "@material-ui/icons/Person";
import Notifications from "@material-ui/icons/Notifications";
import Dashboard from "@material-ui/icons/Dashboard";
import Search from "@material-ui/icons/Search";
import DeveloperBoard from "@material-ui/icons/DeveloperBoard";

// core components
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import headerLinksStyle from "assets/jss/material-dashboard-pro-react/components/headerLinksStyle";
import Autosuggest from "../Select/Autosuggest";
import Api, { role } from "../../api/Api.js";
import SearchEndpoints from "../../api/SearchEndpoints";
import { store } from "../../redux/store";
import { push } from "connected-react-router";
import { Link } from "react-router-dom"
import NotificationsList from "../Notifications/NotificationsList";
import { connect } from "react-redux";

class HeaderLinks extends React.Component {
  state = {
    open: false,
    searchSuggestions: [],
    searchLoading: false
  };
  handleClick = () => {
    this.setState({ open: !this.state.open });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  render() {
    const { classes, rtlActive } = this.props;
    const { open } = this.state;
    const searchButton =
      classes.top +
      " " +
      classes.searchButton +
      " " +
      classNames({
        [classes.searchRTL]: rtlActive
      });
    const dropdownItem = classNames(
      classes.dropdownItem,
      classes.primaryHover,
      { [classes.dropdownItemRTL]: rtlActive }
    );
    const wrapper = classNames({
      [classes.wrapperRTL]: rtlActive
    });
    const managerClasses = classNames({
      [classes.managerClasses]: true
    });
    return (
      <div className={wrapper}>
        <Autosuggest
          innerRef={searchBar => this.searchBar = searchBar}
          placeholder="Search..."
          retrieveSuggestions={(value) => new Promise((resolve, reject) => {
            if (value && value.length >= 3) {
              Api.get(SearchEndpoints.quick, { q: value })
                .then(({ data }) => {
                  resolve((data && data.length > 5) ? data.slice(0, 5) : data);
                }).catch((e) => {
                  console.error(e);
                  resolve([])
                });
            }
            else {
              resolve([]);
            }
          })}
          keySelector={(suggestion) => (suggestion || { term: '' }).term}
          labelSelector={(suggestion) => (suggestion || { term: '' }).term}
          onOuterClick={(innerProps) => {
            innerProps.setState({ inputValue: '' });
          }}
          onSelect={(suggestion, innerProps) => {
            store.dispatch(push(suggestion.location));
            innerProps.setState({ inputValue: '' })
          }}
        />
        <Button
          color="white"
          aria-label="edit"
          justIcon
          round
          className={searchButton}
        >
          <Search
            className={classes.headerLinksSvg + " " + classes.searchIcon}
          />
        </Button>
        <Button
          color="transparent"
          simple
          aria-label="Dashboard"
          justIcon
          className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
          muiClasses={{
            label: rtlActive ? classes.labelRTL : ""
          }}
          component={Link}
          to="/dashboard"
        >
          <Dashboard
            className={
              classes.headerLinksSvg +
              " " +
              (rtlActive
                ? classes.links + " " + classes.linksRTL
                : classes.links)
            }
          />
          <Hidden mdUp implementation="css">
            <span className={classes.linkText}>
              {rtlActive ? "لوحة القيادة" : "Dashboard"}
            </span>
          </Hidden>
        </Button>
        <div className={managerClasses}>
          <Button
            color="transparent"
            justIcon
            aria-label="Notifications"
            aria-owns={open ? "menu-list" : null}
            aria-haspopup="true"
            onClick={this.handleClick}
            className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
            muiClasses={{
              label: rtlActive ? classes.labelRTL : ""
            }}
            buttonRef={node => {
              this.anchorEl = node;
            }}
          >
            <Notifications
              className={
                classes.headerLinksSvg +
                " " +
                (rtlActive
                  ? classes.links + " " + classes.linksRTL
                  : classes.links)
              }
            />
            {this.props.unreadNotifications > 0 ? <span className={classes.notifications}>{this.props.unreadNotifications}</span> : null}
            <Hidden mdUp implementation="css">
              <span onClick={this.handleClick} className={classes.linkText}>
                {rtlActive ? "إعلام" : "Notification"}
              </span>
            </Hidden>
          </Button>
          <Popper
            open={open}
            anchorEl={this.anchorEl}
            transition
            disablePortal
            placement="bottom"
            className={classNames({
              [classes.popperClose]: !open,
              [classes.pooperResponsive]: true,
              [classes.pooperNav]: true
            })}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                id="menu-list"
                style={{ transformOrigin: "0 0 0" }}
              >
                <Paper className={classes.dropdown}>
                  <ClickAwayListener onClickAway={this.handleClose}>
                    <NotificationsList close={this.handleClose} />
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
        {
          role.toLowerCase() !== "client" ?
            <Button
              color="transparent"
              aria-label="Person"
              justIcon
              className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
              muiClasses={{
                label: rtlActive ? classes.labelRTL : ""
              }}
              component={Link}
              to="/profile"
            >
              <Person
                className={
                  classes.headerLinksSvg +
                  " " +
                  (rtlActive
                    ? classes.links + " " + classes.linksRTL
                    : classes.links)
                }
              />
              <Hidden mdUp implementation="css">
                <span className={classes.linkText}>
                  {rtlActive ? "الملف الشخصي" : "Profile"}
                </span>
              </Hidden>
            </Button>
            : 
            null
        }

        {
          role.toLowerCase() === "admin" ?
            <Button
              color="transparent"
              aria-label="Developer Dashboard"
              justIcon
              className={classes.buttonLink}
              component={Link}
              to="/devdashboard"
            >
              <DeveloperBoard
                className={classes.headerLinksSvg + " " + classes.links}
              />
              <Hidden mdUp implementation="css">
                <span className={classes.linkText}>
                  {rtlActive ? "الملف الشخصي" : "Developer Dashboard"}
                </span>
              </Hidden>
            </Button>
            :
            null
        }
      </div>
    );
  }
}

HeaderLinks.propTypes = {
  classes: PropTypes.object.isRequired,
  rtlActive: PropTypes.bool
};

const mapStateToProps = (state) => {
  return {
    unreadNotifications: state.notifications ? state.notifications.length : 0
  }
}

export default withStyles(headerLinksStyle)(connect(mapStateToProps)(HeaderLinks));
